import { styled } from "@mui/material";

export const VerticalStackWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexFlow: "column",
  gap: theme.spacing(4),
}));
